import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { WhatIfSection } from './components/WhatIfSection';
import { PainSection } from './components/PainSection';
import { KnowingSection } from './components/KnowingSection';
import { TurnSection } from './components/TurnSection';
import { SystemIntro } from './components/SystemIntro';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ObjectionSection } from './components/ObjectionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const PIXEL_ID = '2006836796695731';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="d3cu5nj4soeg">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="d45v27vesjoo" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory" data-id="element-2" data-mp="3gj1sm7wwox36">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="3bkgqu420a5cm" />}
        <main data-id="element-4" data-mp="3qaxulu2457co">
          <Hero data-id="element-5" data-mp="3qbfvj3zq09qx" />
          <WhatIfSection data-id="element-6" data-mp="3qbze8mx73260" />
          <PainSection data-id="element-7" data-mp="3qdaienujybxn" />
          <KnowingSection data-id="element-8" data-mp="3lkhbbtbm2rie" />
          <TurnSection data-id="element-9" data-mp="3lk7k62etyeb4" />
          <SystemIntro data-id="element-10" data-mp="3liwkoesf3spt" />
          <ModulesSection data-id="element-11" data-mp="3liehszb92g8x" />
          <BonusSection data-id="element-12" data-mp="2xumznf3138zq" />
          <BenefitsSection data-id="element-13" data-mp="2xtv76d4q9rdo" />
          <ObjectionSection data-id="element-14" data-mp="2xt29s2rnse87" />
          <BeforeAfterSection data-id="element-15" data-mp="2svtmxovkfm0m" />
          <PricingSection data-id="element-16" data-mp="2swlgyv9ilbos" />
          <Guarantee data-id="element-17" data-mp="2svadyxnw87yq" />
          <Testimonials data-id="element-18" data-mp="2stzcx5lu1ebb" />
          <FAQ data-id="element-19" data-mp="18e171cv5hagc" />
          <FinalCTA data-id="element-20" data-mp="18dhopv1l8k1s" />
        </main>
        <Footer data-id="element-21" data-mp="18cgh60js6fot" />
      </div>
    </>;
}